import { makeAutoObservable, runInAction } from "mobx";
import { User, LoginRequest } from "../types";
import { apiService } from "../services/api";

class AuthStore {
    user: User | null = null;
    token: string | null = null;
    isAuthenticated = false;
    loading = false;
    error: string | null = null;

    constructor() {
        makeAutoObservable(this);
        this.checkAuth();
    }

    login = async (credentials: LoginRequest): Promise<void> => {
        runInAction(() => {
            this.loading = true;
            this.error = null;
        });

        try {
            const response = await apiService.login(credentials);

            runInAction(() => {
                this.token = response.token;
                this.user = response.user;
                this.isAuthenticated = true;
                this.loading = false;
            });

            // Сохраняем в localStorage
            localStorage.setItem("token", response.token);
            localStorage.setItem("user", JSON.stringify(response.user));
        } catch (error: any) {
            runInAction(() => {
                this.error = error.response?.data?.message || "Ошибка авторизации";
                this.loading = false;
            });
            throw error;
        }
    };

    logout = (): void => {
        this.user = null;
        this.token = null;
        this.isAuthenticated = false;
        this.error = null;

        // Очищаем localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("user");
    };

    checkAuth = async (): Promise<void> => {
        const token = localStorage.getItem("token");
        const userStr = localStorage.getItem("user");

        if (token && userStr) {
            try {
                runInAction(() => {
                    this.token = token;
                    this.user = JSON.parse(userStr);
                    this.isAuthenticated = true;
                });

                // Проверяем актуальность токена и обновляем данные пользователя
                const currentUser = await apiService.getCurrentUser();
                runInAction(() => {
                    this.user = currentUser;
                    // Обновляем localStorage с актуальными данными
                    localStorage.setItem("user", JSON.stringify(currentUser));
                });
            } catch (error) {
                this.logout();
            }
        }
    };

    clearError = (): void => {
        this.error = null;
    };
}

export const authStore = new AuthStore();
